// Builds the authorised url for a media link, and is deliberately free of imports so it can be
// unit tested: everything else on this path pulls in the api client and app config.
//
// REFUSES to fall back to the stored bucket url when a credential could not be obtained. That
// fallback used to exist, and it was the reason the audited route was optional rather than
// guaranteed: a failed mint rendered an identical-looking image while the read went unrecorded, so
// the accounting quietly understated what had been disclosed. Throwing makes the failure visible
// instead: the caller turns it into a missing image and a Sentry error, which is the honest
// outcome while a read we cannot account for is not.
export const buildAuthorizedMediaUrl = (params: {
    href: string;
    token?: string;
    apiBaseUrl: string;
}): string => {
    const { href, token, apiBaseUrl } = params;

    if (!token) {
        throw new Error('cannot authorise a media read: no media token');
    }

    const separator = href.includes('?') ? '&' : '?';
    return `${apiBaseUrl}${href}${separator}authorization=${encodeURIComponent(`JWT ${token}`)}`;
};
